//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The personalization field model
* 
* @param fieldLabel The field label
* @param fieldName The field name
* @param fieldType The field type
* @param fieldValue The value as string
* @param requiredForAdmission is field required later at admission
* @param requiredForOrder is field required in order process
*/
@Serializable

data class PersonalizationField (


      /* The field label */
    @SerialName(value = "fieldLabel") @Required val fieldLabel: kotlin.String,


      /* The field name */
    @SerialName(value = "fieldName") @Required val fieldName: kotlin.String,


      /* The field type */
    @SerialName(value = "fieldType") @Required val fieldType: kotlin.String,


      /* The value as string */
    @SerialName(value = "fieldValue") val fieldValue: kotlin.String? = null,


      /* is field required later at admission */
    @SerialName(value = "requiredForAdmission") val requiredForAdmission: kotlin.Boolean? = null,


      /* is field required in order process */
    @SerialName(value = "requiredForOrder") val requiredForOrder: kotlin.Boolean? = null


) {




  }

